import { type DocumentDetailsRelease } from "~/api/types";
import { DocumentArtifactStatus } from "~/config/types";
import { useUserContext } from "~/hooks/useUserContext";

export const useSpeEditPermissions = (release: DocumentDetailsRelease) => {
  const { user } = useUserContext();

  const isSpeUserWithoutSso = user.isUsingSpe && !user.isSsoEnabled;

  // For customers that use SPE, disable the action for draft artifacts if the user has no write permissions
  // This is because SPE permissions are currently more coarse-grained
  const canNotEditSpeDraftFile =
    user.isUsingSpe &&
    release.artifact.status === DocumentArtifactStatus.draft &&
    !release.artifact.permissions.canWrite;

  return { isSpeUserWithoutSso, canNotEditSpeDraftFile };
};
